import { Button } from '@mui/material';
import { isDeleteAllowed, isUpdateAllowed } from '../../../utils/common-utils';
import { convertToCamelCaseFromUnderScore } from '../../../../common-utilities/utils';

export const getHeaderConfig = (editVendor, setDeleteDetails) => {
  const headers = [
    {
      label: 'Vendor Name',
      id: 'name',
    },
    {
      label: 'Vendor Code',
      id: 'vendorCode',
    },
    {
      label: 'Item Name',
      id: 'categoryType',
      render: (data) => {
        const { item = {} } = data;
        return item?.name;
      },
    },
    {
      label: 'Item Code',
      id: 'item.itemCode',
    },
    {
      label: 'Price',
      id: 'price',
    },
    {
      label: 'Tax Percentage',
      id: 'taxPercentage',
    },
    {
      label:"Status",
      id:"status",
      render: (data) => {
        return `${convertToCamelCaseFromUnderScore(data.status)} ${data?.approvalId?.pendingWith ? `(${data?.approvalId?.pendingWith})` : ''}`;
      }
    },
    {
      label: 'Actions',
      id: 'actions',
      render: (data) => {
        return (
          <>
            <Button
              disabled={!isUpdateAllowed('master_data')||data?.status==="approval_in_progress"}
              variant="text"
              onClick={() => editVendor(data, 'EDIT')}
            >
              Edit
            </Button>
            <Button
              variant="text"
              disabled={!isDeleteAllowed('master_data')||data?.status==="approval_in_progress"}
              onClick={() => setDeleteDetails(data)}
            >
              Delete
            </Button>
          </>
        );
      },
    },
  ];
  return headers;
};
